import React from "react";

import AthleteContactRequestsPage from "../components/dashboard/AthleteContactRequestsPage";
import { useAuth } from "../context/AuthContext";
import { useNotifications } from "../components/layout/routing/AppShell";

const AthleteContactRequestsRoute = () => {
  const { athleteData } = useAuth();
  const { refreshPendingContactCount } = useNotifications();

  return (
    <AthleteContactRequestsPage
      athleteId={athleteData?.id}
      athleteFullName={athleteData?.full_name}
      guardianEmail={athleteData?.guardian_email}
      onResolved={refreshPendingContactCount}
    />
  );
};

export default AthleteContactRequestsRoute;
